module.exports = __webpack_public_path__ + "img/1_2_m.dee874ab.jpg";